import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Pages.css';
import GoogleIntegrationCard from '../components/GoogleIntegrationCard';

function AdminDashboard({ apiUrl, token }) {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${apiUrl}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setStats(res.data))
      .catch((err) => setError(err.response?.data?.error || 'Failed to load stats'));
  }, [apiUrl, token]);

  const countFor = (rows, key) => {
    const row = rows?.find((r) => r.role === key || r.status === key);
    return row ? parseInt(row.count, 10) : 0;
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Admin Dashboard</h1>
      </div>
      {error && <div className="error-message">{error}</div>}
      {stats && (
        <>
          <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
            <div className="stat-tile">
              <div className="stat-value">{countFor(stats.users_by_role, 'client')}</div>
              <div className="stat-label">Clients</div>
            </div>
            <div className="stat-tile">
              <div className="stat-value">{countFor(stats.users_by_role, 'practitioner')}</div>
              <div className="stat-label">Practitioners</div>
            </div>
            <div className="stat-tile">
              <div className="stat-value">{stats.total_services}</div>
              <div className="stat-label">Services</div>
            </div>
            <div className="stat-tile">
              <div className="stat-value">${parseFloat(stats.total_revenue).toFixed(2)}</div>
              <div className="stat-label">Revenue Collected</div>
            </div>
          </div>

          <div className="card" style={{ marginTop: 20 }}>
            <div className="card-header">Bookings by Status</div>
            <div className="flex-between" style={{ flexWrap: 'wrap', gap: 16 }}>
              {['pending', 'awaiting_payment', 'confirmed', 'completed', 'rejected'].map((status) => (
                <div key={status} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.4rem', fontWeight: 800 }}>{countFor(stats.bookings_by_status, status)}</div>
                  <span className={`badge badge-${status}`}>{status.replace('_', ' ')}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid" style={{ marginTop: 20 }}>
            <Link to="/admin/users" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card-header">👥 Manage Users</div>
              <p className="text-muted">Create and edit clients, practitioners, and admins</p>
            </Link>
            <Link to="/admin/services" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card-header">✨ Manage Services</div>
              <p className="text-muted">View and edit every service across all practitioners</p>
            </Link>
            <Link to="/admin/coupons" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card-header">🏷️ Manage Coupons</div>
              <p className="text-muted">Create and manage discount coupons</p>
            </Link>
            <Link to="/admin/bookings" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card-header">📅 All Bookings</div>
              <p className="text-muted">System-wide booking visibility and status overrides</p>
            </Link>
          </div>
        </>
      )}

      <GoogleIntegrationCard
        apiUrl={apiUrl}
        token={token}
        title="Central Bookings Calendar & Domain Mail"
        description="Connect the shared/domain Google account (e.g. bookings@yourdomain.com) here. Every confirmed booking across all practitioners gets mirrored onto this account's calendar."
      />
    </div>
  );
}

export default AdminDashboard;
